import {getDiscoveryEventKey} from "./getDiscoveryPageViewMetadata";

export const DISCOVERY_PAGE_EVENT_KEY_REGISTER_OPTIONS = {
	persistent: false,
} as const;

type MixpanelWithRegister = {
	register: (
		props: Record<string, string>,
		days_or_options?: number | {persistent?: boolean}
	) => void;
};

/** In-memory register so page `event_key` does not persist to localStorage. */
export function registerDiscoveryPageEventKey(
	mixpanel: MixpanelWithRegister | null,
	pathname: string
): void {
	mixpanel?.register(
		{event_key: getDiscoveryEventKey(pathname)},
		DISCOVERY_PAGE_EVENT_KEY_REGISTER_OPTIONS
	);
}
